export default "__VITE_ASSET__762efba3__"